import { PageBaseInternal } from '../../../../webmodule-common/other/ui/pages/page-base';

export class PageBase extends PageBaseInternal {
  protected defaultTitleTemplate = `%s | License Server Module`;

  async loadUserCoreDetails() {
    //no details
  }
}
